import { useAtomValue } from "jotai";
import { classNames as originalClassNames } from "@NBCUDTC/reactjs-utility-belt/classnames";

import { platformAtom } from "@/constants/atoms";

/**
 * Enhanced classNames utility that automatically includes platform-specific classes
 *
 * @param styles - CSS modules styles object (should contain platform-\{mobile|web|tv\} classes)
 * @param baseClasses - Base classes to apply
 * @returns Combined class name string with platform-specific class
 *
 * @example
 * const cn = useClassNames(styles, styles["button"], className);
 * // Returns: "button platform-mobile custom-class" (if platform is mobile)
 */
const useClassNames = (
  styles: Record<string, string>,
  ...baseClasses: (string | undefined | false | null)[]
): string => {
  const platform = useAtomValue(platformAtom);
  const platformClass = styles[`platform-${platform}`];

  return originalClassNames(...baseClasses, platformClass);
};

export { useClassNames };
